import AudioMutedIndicator from 'jitsi/filmstrip/components/web/AudioMutedIndicator';
import ModeratorIndicator from 'jitsi/filmstrip/components/web/ModeratorIndicator';
import ScreenShareIndicator from 'jitsi/filmstrip/components/web/ScreenShareIndicator';
import ThumbnailCameraIndicator from './ThumbnailCameraIndicator';
import { getParticipantByIdOrUndefined, isScreenShareParticipantById } from 'jitsi/base/participants/functions';
import { getVideoTrackByParticipant, isLocalTrackMuted, isRemoteTrackMuted } from 'jitsi/base/tracks/functions.web';
import { MEDIA_TYPE } from 'jitsi/base/media/constants';
import { PARTICIPANT_ROLE } from 'jitsi/base/participants/constants';
import { getIndicatorsTooltipPosition } from 'jitsi/filmstrip/functions.web';
import { connect } from 'react-redux';
import React from 'react';
class IISightStatusIndicators extends React.Component {
    render() {
        const { _showAudioMutedIndicator, _showModeratorIndicator, _showScreenShareIndicator, _showCameraIcon, thumbnailType } = this.props;
        const tooltipPosition = getIndicatorsTooltipPosition(thumbnailType);
        return (React.createElement(React.Fragment, null,
            _showAudioMutedIndicator && React.createElement(AudioMutedIndicator, { tooltipPosition: tooltipPosition }),
            _showCameraIcon && React.createElement(ThumbnailCameraIndicator, { tooltipPosition: tooltipPosition }),
            _showModeratorIndicator && React.createElement(ModeratorIndicator, { tooltipPosition: tooltipPosition }),
            _showScreenShareIndicator && React.createElement(ScreenShareIndicator, { tooltipPosition: tooltipPosition })));
    }
}
export function mapStateToProps(state, ownProps) {
    const { participantID, audio, moderator, screenshare } = ownProps;
    const participant = getParticipantByIdOrUndefined(state, participantID);
    const tracks = state['features/base/tracks'];
    let isAudioMuted = true;
    let isScreenSharing = false;
    let isCamMuted = true;
    if (participant?.local) {
        isAudioMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
        isCamMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
    }
    else if (!participant?.fakeParticipant || isScreenShareParticipantById(state, participantID)) {
        const track = getVideoTrackByParticipant(state, participant);
        isScreenSharing = track?.videoType === 'desktop';
        isAudioMuted = isRemoteTrackMuted(tracks, MEDIA_TYPE.AUDIO, participantID);
        isCamMuted = isRemoteTrackMuted(tracks, MEDIA_TYPE.VIDEO, participantID);
    }
    const { disableModeratorIndicator } = state['features/base/config'];
    return {
        _showAudioMutedIndicator: isAudioMuted && audio,
        _showModeratorIndicator: !disableModeratorIndicator && participant && participant.role === PARTICIPANT_ROLE.MODERATOR && moderator,
        _showScreenShareIndicator: isScreenSharing && screenshare,
        _showCameraIcon: isCamMuted,
    };
}
export default connect(mapStateToProps)(IISightStatusIndicators);
